// extracted by mini-css-extract-plugin
export default {"bucketObjectsViewSelect":"BucketObjects_bucketObjectsViewSelect__A5yn7","bucketObjectsViewSelectButton":"BucketObjects_bucketObjectsViewSelectButton__DFPKX"};